<template>
  <div class="bg-payment"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-payment {
  position: fixed;
  background-image: url(/img/programs/fellowship/mayo/BgPaymentMayo.png);
  background-size: cover;
  background-position: center;
  top: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 767px) {
  .bg-payment {
    background-image: url(/img/programs/fellowship/mayo/BgPaymentMayoSP.png);
  }
}
</style>
